import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Loader2, RotateCw, FlaskConical } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { AdminLayout } from "../components/AdminLayout";

export default function DevSaasLog() {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = () => {
    setLoading(true);
    api
      .get("/admin/dev/saas-mock-log")
      .then((r) => setData(r.data))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (user?.dev_tools) load();
  }, [user]);

  if (!user?.dev_tools) return <Navigate to="/admin" replace />;

  return (
    <AdminLayout
      title="Mock SaaS — requêtes reçues"
      subtitle={
        <span className="inline-flex items-center gap-1.5">
          <FlaskConical className="h-3.5 w-3.5" /> Environnement de développement ·{" "}
          <span className="font-mono text-xs">{data?.file}</span>
        </span>
      }
      actions={
        <button
          onClick={load}
          disabled={loading}
          className="inline-flex items-center gap-2 rounded-md border border-slate-300 bg-white px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50 disabled:opacity-60"
          data-testid="saas-log-refresh-button"
        >
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <RotateCw className="h-4 w-4" />} Rafraîchir
        </button>
      }
    >
      {!data ? (
        <div className="flex justify-center py-20">
          <Loader2 className="h-6 w-6 animate-spin text-slate-400" />
        </div>
      ) : data.entries.length === 0 ? (
        <p className="rounded-xl border border-slate-300 bg-white py-16 text-center text-sm text-slate-500" data-testid="saas-log-empty">
          Aucune requête reçue par le mock pour le moment.
        </p>
      ) : (
        <ul className="space-y-3" data-testid="saas-log-list">
          {data.entries.map((e) => (
            <li key={e.id} className="rounded-xl border border-slate-300 bg-white">
              <details data-testid={`saas-log-entry-${e.id}`}>
                <summary className="flex cursor-pointer flex-wrap items-center gap-x-4 gap-y-1 px-5 py-3 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600">
                  <span className="text-slate-600">{new Date(e.logged_at).toLocaleString("fr-FR")}</span>
                  <span
                    className={`rounded-full px-2.5 py-0.5 text-xs font-semibold ${
                      e.response_status < 300 ? "bg-emerald-100 text-emerald-700" : "bg-red-100 text-red-700"
                    }`}
                  >
                    HTTP {e.response_status}
                  </span>
                  <span className="font-medium text-slate-900">{e.payload.right_type}</span>
                  <span className="font-mono text-xs text-slate-500">{e.payload.org_id}</span>
                  <span className="font-mono text-xs text-slate-400">{e.payload.submission_id}</span>
                </summary>
                <pre className="overflow-x-auto rounded-b-xl bg-slate-900 p-4 font-mono text-xs leading-relaxed text-slate-100">
                  {JSON.stringify({ headers: e.headers, payload: e.payload, response: e.response }, null, 2)}
                </pre>
              </details>
            </li>
          ))}
        </ul>
      )}
    </AdminLayout>
  );
}
